var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, css, nothing } from 'lit';
import { PICBase, customElement, stringDecoder, PICAction, objectDecoder } from '../Internals';
import { property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { classMap } from 'lit/directives/class-map.js';
import { isSvgSrc, fetchIsSvgMonochrome } from '../../util/SvgColor';
let PICImage = class PICImage extends PICBase {
    constructor() {
        super(...arguments);
        this.src = '/images/no-image.svg';
        this.width = '250px';
        this.height = '250px';
        // Is this SVG grayscale/monochrome (safe to contrast-compress for dark mode) or does it
        // contain actual color (a logo etc.) that must be left alone.
        this.isMonoSvg_ = false;
    }
    willUpdate(changedProperties) {
        if (changedProperties.has('src')) {
            this.isMonoSvg_ = false;
            const src = this.src;
            if (isSvgSrc(src)) {
                fetchIsSvgMonochrome(src).then(isMono => {
                    if (this.src === src) {
                        this.isMonoSvg_ = isMono;
                        this.requestUpdate();
                    }
                });
            }
        }
    }
    static get styles() {
        const defaultStyle = css `
        :host{
           padding: 1px;
        }

        .pic-image{
            width: 100%;
            height: 100%;
            object-fit: fill;
        }

        .pic-image.clickable:hover {
            cursor: pointer;
        }

        /* Grayscale/monochrome SVGs only (see isMonoSvg_): compresses the tonal range toward
           mid-gray so black line art doesn't disappear against a dark page background. Inert
           in light mode - --pic-imageMonoContrast is only defined under [data-theme="dark"]
           in webtoolbox.css. */
        .pic-image.mono-svg {
            filter: contrast(var(--pic-imageMonoContrast, 1));
        }

        `;
        return css `
        ${super.styles}
        ${defaultStyle}
        `;
    }
    focus() {
    }
    validateSubmit() {
        return true;
    }
    connectedCallback() {
        super.connectedCallback();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    getImageStyle() {
        return {
            'width': this.width,
            'height': this.height,
        };
    }
    getImageClass() {
        return {
            'pic-image': true,
            'clickable': this.clickAction ? true : false,
            'mono-svg': this.isMonoSvg_
        };
    }
    handleClick(e) {
        if (this.clickAction) {
            try {
                let myAction = new PICAction();
                myAction.actionOptions = this.clickAction;
                myAction.triggerEvent(e);
            }
            catch (_a) {
                console.log('invalid action:', this.clickAction);
            }
        }
    }
    handleError(e) {
        this.src = '/images/no-image.svg';
        this.requestUpdate();
    }
    render() {
        return html `
        ${this.renderCSS(true)}
        <div 
            style=${styleMap(this.getImageStyle())}
            @click=${this.handleClick}>
            <img 
                src=${this.src} 
                class=${classMap(this.getImageClass())}
                @error=${this.handleError}
            >
        </div>
        ${this.tooltip_ ? html `<pic-tooltip>${this.tooltip_}</pic-tooltip>` : nothing}
    `;
    }
};
__decorate([
    property({ converter: stringDecoder })
], PICImage.prototype, "src", void 0);
__decorate([
    property({ converter: stringDecoder })
], PICImage.prototype, "width", void 0);
__decorate([
    property({ converter: stringDecoder })
], PICImage.prototype, "height", void 0);
__decorate([
    property({ converter: objectDecoder })
], PICImage.prototype, "clickAction", void 0);
PICImage = __decorate([
    customElement('pic-image')
], PICImage);
export { PICImage };
//# sourceMappingURL=PICImage.js.map